import { render, staticRenderFns } from "./HsaBankFooterRoot.vue?vue&type=template&id=6d55d64a"
import script from "./HsaBankFooterRoot.vue?vue&type=script&lang=ts"
export * from "./HsaBankFooterRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports